<template>
  <div class="row">
    <div class="col text-truncate" v-show="showNextMusic">
      <div class="proximas_ultimas_musicas">
        <h2>Próximas  </h2>
        <ul>
          <li v-for="( item , index) in upcoming">
            <img :src="item.cover" alt="Gusttavo Lima"/>
            <span>{{ index + 1 }}</span>
            <strong class="d-inline-block text-truncate">{{ item.tags.title }}</strong>
            <small class="d-inline-block text-truncate">{{ item.tags.name }}</small>
            <p class="capa-ampliada"><img :src="item.cover"/></p>
          </li>
        </ul>
      </div>
      <!--SEM PROXIMAS-->
      <div v-if="!upcoming" class="proximas_ultimas_musicas">
        <ul>
          <li v-for="index in 5" :key="index">
            <i class="fas fa-music"></i>
            <span>{{ index   }}</span>
            <strong class="nenhuma-musica"> Nenhuma música ainda</strong>
          </li>
        </ul>
      </div>
    </div>
    <div class="col text-truncate" v-show="showPreviusMusic">
      <div class="proximas_ultimas_musicas">
        <h2>últimas tocadas</h2>
        <ul v-if="historic" >
          <li v-for="( item , index) in historic">
            <img :src="item.cover" alt="Gusttavo Lima"/>
            <span>{{ index + 1 }}</span>
            <strong class="d-inline-block text-truncate">{{ item.tags.title }}</strong>
            <small class="d-inline-block text-truncate">{{ item.tags.name }}</small>
            <p class="capa-ampliada"><img :src="item.cover"/></p>
          </li>
        </ul>
      </div>
      <!--SEM ULTIMA-->
      <div v-if="!historic" class="proximas_ultimas_musicas">
        <ul>
          <li v-for="index in 5" :key="index">
            <i class="fas fa-music"></i>
            <span>{{ index   }}</span>
            <strong class="nenhuma-musica"> Nenhuma música ainda</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

  import services from '../service/api'

  export default {
    name: "NextMusic",
    props:[],
    data(){
      return {
        historic:window.config.historic,
        upcoming:window.config.upcoming,
        hotsite_config:{
          previusMusic:'',
          nextMusic:''
        },
        showPreviusMusic:window.config.site.showPreviusMusic,
        showNextMusic:window.config.site.showNextMusic
      }
    },
    mounted(){
      let self = this;
      setInterval(function () {
        services.getWithoutToken(window.config.urlhistoric).then(function (response) {
          self.historic = response.data.data;
        });
        services.getWithoutToken(window.config.urlupcoming).then(function (response) {
          self.upcoming = response.data.data;
        });
      }, 10000);
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/NextMusic.vue